import { ContextStore, ExperimentStore } from 'bernie-core';
import { PageData } from 'bernie-http';

/**
 * This utility function is meant for store operations ONLY,
 * where a determination must be made about which network call to make.
 * All attempts should be made first to either log server-side or use <AbacusExperiment />.
 */
export function evaluateAndLogExperiment(
  experimentName: string,
  context: ContextStore,
  experiments: ExperimentStore,
  pageData: PageData
): number | null {
  const experiment = experiments?.exposures[experimentName];

  if (experiment) {
    experiments.logExperiment(context, pageData, experiment);

    return experiment.bucket;
  }

  return null;
}
